import React, { useEffect, useState } from "react";
import styles from "./Layout.module.scss";
import server from "src/api/server";
import Link from "next/link";
import dynamic from "next/dynamic";

const WhatsAppIcon = dynamic(() => import("../shared/WhatsAppIcon"), {
  loading: () => <span className={styles.whatsappPlaceholder} />,
  ssr: false,
});

export default function Layout({ children }) {
  const [data, setData] = useState({});

  useEffect(() => {
    let isMounted = true;
    const fetchData = async () => {
      try {
        const res = await server.get("/api/footer");
        if (isMounted) {
          setData(res?.data?.data);
        }
      } catch (error) {
        console.error("Failed to fetch footer data:", error);
      }
    };
    fetchData();

    return () => {
      isMounted = false;
    };
  }, []);

  const onWhatsAppClick = () => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "whatsapp_click",
      page: `https://wa.me/${data?.socials?.whatsApp.split(" ").join("")}`,
    });

    window.open(
      `https://wa.me/${data?.socials?.whatsApp.split(" ").join("")}`,
      "_blank"
    );
  };
  return (
    <>
      <div className={styles.button}>
        <Link
          href={`https://wa.me/${
            data?.socials?.whatsApp?.split(" ").join("") || ""
          }`}
          rel="noreferrer"
        >
          <a
            target="_blank"
            aria-label="Whatsapp"
            onClick={(e) => {
              e.preventDefault();
              onWhatsAppClick();
            }}
          >
            <WhatsAppIcon />
          </a>
        </Link>
      </div>
      <main>{children}</main>
    </>
  );
}
